import React from 'react';

import Layout from '../Layout';
import ErrorBoundary from './errorBoundary';

// This is just an example implementation to force an error page to be displayed
const ErrorPage = () => {
  return (
    <Layout>
      <ErrorBoundary error={true}/>
    </Layout>
    )
  }

  export { ErrorBoundary, ErrorPage };
